import React from 'react'
import { AgGridReact } from "ag-grid-react";
import ModalBasic from '../../component/ModalBasic';
import TextInput from '../../../components/UIComponent/TextInput';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.1,
        flex: 1.0,
        filter: true,
    },
    {
        field: "materialType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "returnQuantity",
        headerName: "Return quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    // {
    //     field: "storeTransferQty",
    //     headerName: "Store transfer qty",
    //     minWidth: window.innerWidth * 0.08,
    //     flex: 0.6,
    //     filter: true,
    // },
    // {
    //     field: "disAssembleQty",
    //     headerName: "DisAssemble qty",
    //     minWidth: window.innerWidth * 0.08,
    //     flex: 0.6,
    //     filter: true,
    // },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.7,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.07,
        flex: 0.7,
        filter: true,
    },
    // {
    //     field: "discount",
    //     headerName: "Discount(%)",
    //     minWidth: window.innerWidth * 0.06,
    //     flex: 0.6,
    //     filter: true,
    // },
    // {
    //     field: "extraCharges",
    //     headerName: "Extra charges",
    //     minWidth: window.innerWidth * 0.06,
    //     flex: 0.6,
    //     filter: true,
    // },
    {
        field: "total",
        headerName: "Taxable amount",
        minWidth: window.innerWidth * 0.07,
        flex: 0.7,
        filter: true,
    },
    {
        field: "sgst",
        headerName: "SGST",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "sgstAmt",
        headerName: "SGST amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgst",
        headerName: "CGST",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "cgstAmt",
        headerName: "CGST amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igst",
        headerName: "IGST",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "igstAmt",
        headerName: "IGST amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "netTotal",
        headerName: "Net total",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];

export const SalesReturnPopup = (props) => {
    return (
        <ModalBasic
            id="sales-return"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Sales return details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Return no</label>
                        <TextInput type='text'
                            id='returnNo' name='returnNo'
                            value={props.salesObject.returnNo}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'returnNo')}
                            className={props.validState?.error?.returnNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Return date</label>
                        <TextInput type='date'
                            id='returnDate' name='returnDate'
                            value={props.salesObject.returnDate}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'returnDate')}
                            className={props.validState?.error?.returnDate !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Auth. employee</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select employee"
                            options={props.salesObject.EmployeeList}
                            value={props.salesObject.authorizedBy ? props.salesObject.EmployeeList.find(x => x.value === props.salesObject.authorizedBy) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "authorizedBy", 'salesObject')
                            }
                            className={props.validState?.error?.authorizedBy !== undefined ? "error" : ""}
                        /> */}
                        <TextInput type='text'
                            id='usp_Users' name='usp_Users'
                            value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Return from</label>
                        <MultiSelectDropdown
                            drpIdentity="Select return"
                            options={props.salesObject.returnList}
                            value={props.salesObject.idReturn ? props.salesObject.returnList.find(x => x.value === props.salesObject.idReturn) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idReturn", 'salesObject')
                            }
                            className={props.validState?.error?.idReturn !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Gatepass no</label>
                        <MultiSelectDropdown
                            drpIdentity="Select gatepass"
                            options={props.salesObject.gatepassList}
                            value={props.salesObject.idGatePass ? props.salesObject.gatepassList.find(x => x.value === props.salesObject.idGatePass) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idGatePass", 'salesObject')
                            }
                            className={props.validState?.error?.idGatePass !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Customer</label>
                        <MultiSelectDropdown
                            drpIdentity="Select customer"
                            options={props.salesObject.customerList}
                            value={props.salesObject.idCustomer ? props.salesObject.customerList.find(x => x.value === props.salesObject.idCustomer) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idCustomer", 'salesObject')
                            }
                            className={props.validState?.error?.idCustomer !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Sales no</label>
                        <MultiSelectDropdown
                            drpIdentity="Select sales"
                            options={props.salesObject.salesList}
                            value={props.salesObject.idSalesInvoice ? props.salesObject.salesList.find(x => x.value === props.salesObject.idSalesInvoice) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idSalesInvoice", 'salesObject')
                            }
                            className={props.validState?.error?.idSalesInvoice !== undefined ? "error" : ""}
                            isDisabled={props.salesObject.idReturn === 1 ? true : false}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Inv. type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select inv"
                            options={props.salesObject.invList}
                            value={props.salesObject.idInv ? props.salesObject.invList.find(x => x.value === props.salesObject.idInv) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idInv", 'salesObject')
                            }
                            className={props.validState?.error?.idInv !== undefined ? "error" : ""}
                            isDisabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Bill no</label>
                        <TextInput type='text'
                            id='billNo' name='billNo'
                            value={props.salesObject.billNo}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'billNo')}
                            className={props.validState?.error?.billNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Bill date</label>
                        <TextInput type='date'
                            id='billDate' name='billDate'
                            value={props.salesObject.billDate}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'billDate')}
                            className={props.validState?.error?.billDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Account Head</label>
                        <MultiSelectDropdown
                            drpIdentity="Select delivery"
                            options={props.salesObject.accountHeadList}
                            value={props.salesObject.idGeneralProduct ? props.salesObject.accountHeadList.find(x => x.value === props.salesObject.idGeneralProduct) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idGeneralProduct", 'salesObject')
                            }
                            className={props.validState?.error?.idGeneralProduct !== undefined ? "error" : ""}
                        />
                    </div>
                </div>

                <span className="text-blue text-[16px] font-semibold">Sales product details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChangeForItem(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.itemObject.TypeList}
                            value={props.itemObject.idType ? props.itemObject.TypeList.find(x => x.value === props.itemObject.idType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idType", 'itemObject')
                            }
                            className={props.validState?.error?.idType !== undefined ? "error" : ""}
                            isDisabled={props.salesObject.idReturn === 2 ? true : false}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select priority"
                            options={props.itemObject.ItemList}
                            value={props.itemObject.idItem ? props.itemObject.ItemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idItem", 'itemObject')
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                            isDisabled={props.salesObject.idReturn === 2 ? true : false}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.itemObject.itemIdLabel}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                            disabled={(props.salesObject.idReturn === 2 || props.salesObject.idCustomer === 0) ? true : false}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Unit</label>
                        <MultiSelectDropdown
                            drpIdentity="Select unit"
                            options={props.itemObject.unitList}
                            value={props.itemObject.idUnit ? props.itemObject.unitList.find(x => x.value === props.itemObject.idUnit) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idUnit", 'itemObject')
                            }
                            className={props.validState?.error?.idUnit !== undefined ? "error" : ""}
                            isDisabled={(props.salesObject.idReturn === 2) ? true : false}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Return quantity</label>
                        <TextInput type='number'
                            id='returnQuantity' name='returnQuantity'
                            value={props.itemObject.returnQuantity}
                            handleChange={(event) => props.handleChangeForItem(event, 'returnQuantity')}
                            className={props.validState?.error?.returnQuantity !== undefined ? "error" : ""}
                        // disabled={props.salesObject.idReturn === 2 ? true : false}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rate</label>
                        <TextInput type='number'
                            id='rate' name='rate'
                            value={props.itemObject.rate}
                            handleChange={(event) => props.handleChangeForItem(event, 'rate')}
                            className={props.validState?.error?.rate !== undefined ? "error" : ""}
                            disabled={props.salesObject.idReturn === 2 ? true : false}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Amount</label>
                        <TextInput type='number'
                            id='amount' name='amount'
                            value={props.itemObject.amount}
                            handleChange={(event) => props.handleChangeForItem(event, 'amount')}
                            className={props.validState?.error?.amount !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Discount (%)</label>
                        <TextInput type='number'
                            id='discount' name='discount'
                            value={props.itemObject.discount}
                            handleChange={(event) => props.handleChangeForItem(event, 'discount')}
                            className={props.validState?.error?.discount !== undefined ? "error" : ""}
                            disabled={props.salesObject.idReturn === 2 ? true : false}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Charges Amount</label>
                        <TextInput type='number'
                            id='chargeAmt' name='chargeAmt'
                            value={props.itemObject.chargeAmt}
                            handleChange={(event) => props.handleChangeForItem(event, 'chargeAmt')}
                            className={props.validState?.error?.chargeAmt !== undefined ? "error" : ""}
                            disabled={props.salesObject.idReturn === 2 ? true : false}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Total</label>
                        <TextInput type='number'
                            id='total' name='total'
                            value={props.itemObject.total}
                            handleChange={(event) => props.handleChangeForItem(event, 'total')}
                            className={props.validState?.error?.total !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Tax group</label>
                        <MultiSelectDropdown
                            drpIdentity="Select tax"
                            options={props.itemObject.taxList}
                            value={props.itemObject.idTaxGroup ? props.itemObject.taxList.find(x => x.value === props.itemObject.idTaxGroup) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idTaxGroup", 'itemObject')
                            }
                            className={props.validState?.error?.idTaxGroup !== undefined ? "error" : ""}
                            isDisabled={props.salesObject.idReturn === 2 ? true : false}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>SGST {props.itemObject.sgst > 0 ? `- ${props.itemObject.sgst}%` : ""}</label>
                        <TextInput type='number'
                            id='sgstAmt' name='sgstAmt'
                            value={props.itemObject.sgstAmt}
                            handleChange={(event) => props.handleChangeForItem(event, 'sgstAmt')}
                            className={props.validState?.error?.sgstAmt !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>CGST {props.itemObject.cgst > 0 ? `- ${props.itemObject.cgst}%` : ""}</label>
                        <TextInput type='number'
                            id='cgstAmt' name='cgstAmt'
                            value={props.itemObject.cgstAmt}
                            handleChange={(event) => props.handleChangeForItem(event, 'cgstAmt')}
                            className={props.validState?.error?.cgstAmt !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>IGST {props.itemObject.igst > 0 ? `- ${props.itemObject.igst}%` : ""}</label>
                        <TextInput type='number'
                            id='igstAmt' name='igstAmt'
                            value={props.itemObject.igstAmt}
                            handleChange={(event) => props.handleChangeForItem(event, 'igstAmt')}
                            className={props.validState?.error?.igstAmt !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Net total</label>
                        <TextInput type='number'
                            id='netTotal' name='netTotal'
                            value={props.itemObject.netTotal}
                            handleChange={(event) => props.handleChangeForItem(event, 'netTotal')}
                            className={props.validState?.error?.netTotal !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChangeForItem(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                            disabled={props.salesObject.idReturn === 2 ? true : false}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 col-span-2 mt-5'>
                        {props.itemObject.keyId > 0 ?
                            <button
                                className="save-btn btns py-[10px] px-[20px]"
                                onClick={() => props.insert("Update")}
                                disabled={props.itemObject.isInwardStatus}
                            >
                                Update
                            </button>
                            :
                            <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }
                        <button className="edit-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.clearItemObject()}>Clear</button>
                        <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" 
                        disabled={props.itemObject.isInwardStatus}
                        onClick={() => props.delete(props.itemObject.keyId)}>Delete</button>
                    </div>
                </div>
                <div className="register-table h-[40vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='total-amt mt-2.5 p-2.5 bg-[#3f8cff1a] rounded-[10px]'>
                    <span className="text-blue text-[16px] font-semibold">Amount details</span>
                    <div className='input-grp-outer grid grid-cols-8 gap-2.5 mt-2.5'>
                        <div className='input-grp'>
                            <label>Total quantity</label>
                            <TextInput type='number'
                                id='totalQty' name='totalQty'
                                value={props.salesObject.totalQty}
                                handleChange={(event) => props.handleChangeForItem(event, 'totalQty')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total amount</label>
                            <TextInput type='number'
                                id='totalAmt' name='totalAmt'
                                value={props.salesObject.totalAmt}
                                handleChange={(event) => props.handleChangeForItem(event, 'totalAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Extra charges</label>
                            <TextInput type='number'
                                id='extraCharges' name='extraCharges'
                                value={props.salesObject.extraCharges}
                                handleChange={(event) => props.handleChangeForItem(event, 'extraCharges')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Discount amount</label>
                            <TextInput type='number'
                                id='totalDiscountAmt' name='totalDiscountAmt'
                                value={props.salesObject.totalDiscountAmt}
                                handleChange={(event) => props.handleChangeForItem(event, 'totalDiscountAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Taxable amount</label>
                            <TextInput type='number'
                                id='taxableAmt' name='taxableAmt'
                                value={props.salesObject.taxableAmt}
                                handleChange={(event) => props.handleChange(event, 'taxableAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Tax amount</label>
                            <TextInput type='number'
                                id='taxAmt' name='taxAmt'
                                value={props.salesObject.taxAmt}
                                handleChange={(event) => props.handleChangeForItem(event, 'taxAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total with tax</label>
                            <TextInput type='number'
                                id='totalwithTax' name='totalwithTax'
                                value={props.salesObject.totalwithTax}
                                //handleChange={(event) => props.handleChangeForItem(event, 'totalwithTax')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Adjustable amount</label>
                            <TextInput type='number'
                                id='adjustableAmt' name='adjustableAmt'
                                value={props.salesObject.adjustableAmt}
                                handleChange={(event) => props.handleChangeForPurchase(event, 'adjustableAmt')}
                                className='font-semibold'
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Final amount</label>
                            <TextInput type='number'
                                id='finalAmt' name='finalAmt'
                                value={props.salesObject.finalAmt}
                                handleChange={(event) => props.handleChangeForItem(event, 'finalAmt')}
                                className='font-semibold'
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    {/* <button className="print-btn btns">Print</button>
                    <button className="edit-btn btns">Preview</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}